const cards = [
  {
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20illustration%20of%20a%20warrior%20in%20ancient%20Chinese%20fantasy%20setting%2C%20flowing%20robes%2C%20dramatic%20lighting%2C%20warm%20orange%20and%20gold%20color%20palette%2C%20dynamic%20action%20pose%2C%20manga%20panel%20style%20composition&width=600&height=400&seq=card-img-01&orientation=landscape',
    tag: '国漫精选',
    title: '修仙狂徒：逆天改命的修真传奇',
    desc: '平凡少年意外获得上古传承，从此踏上逆天修仙之路。万人追捧的国漫玄幻巅峰之作，热血与感动交织。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Dark%20urban%20anime%20scene%20with%20a%20mysterious%20hunter%20on%20rooftop%20at%20night%2C%20neon%20lights%2C%20dramatic%20shadows%2C%20modern%20Korean%20manhwa%20art%20style%2C%20cool%20color%20accents%20with%20warm%20highlights&width=600&height=400&seq=card-img-02&orientation=landscape',
    tag: '韩漫推荐',
    title: '暗夜猎手：都市夜幕下的正义',
    desc: '白天是普通上班族，夜晚化身城市守护者。韩国顶级画师打造，动作场面堪比电影级别。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20couple%20scene%20in%20modern%20city%20setting%2C%20cherry%20blossoms%2C%20soft%20pink%20and%20warm%20tones%2C%20sweet%20atmosphere%2C%20flat%20illustration%20style%2C%20clean%20lines%2C%20gentle%20lighting&width=600&height=400&seq=card-img-03&orientation=landscape',
    tag: '条漫精选',
    title: '甜蜜陷阱：契约婚姻藏着真心',
    desc: '冷面总裁遇上倔强灰姑娘，一纸契约牵出甜蜜爱情。每周更新，甜到让人嘴角疯狂上扬。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20anime%20spaceship%20interior%20scene%2C%20a%20lone%20astronaut%20looking%20at%20distant%20stars%2C%20deep%20space%20colors%2C%20warm%20cabin%20lighting%2C%20atmospheric%20Japanese%20anime%20style%2C%20contemplative%20mood&width=600&height=400&seq=card-img-04&orientation=landscape',
    tag: '日漫经典',
    title: '星海迷途：宇宙深处的孤独航行',
    desc: '地球毁灭后，最后的幸存者在浩瀚宇宙中寻找新家园。史诗级科幻漫画，每一页都是壁纸级画面。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Martial%20arts%20anime%20character%20training%20in%20ancient%20temple%20courtyard%2C%20falling%20leaves%2C%20warm%20sunset%20light%2C%20traditional%20Chinese%20aesthetic%2C%20dynamic%20ink%20wash%20painting%20style%2C%20powerful%20atmosphere&width=600&height=400&seq=card-img-05&orientation=landscape',
    tag: '国漫新秀',
    title: '武道至尊：以拳破天的武者之路',
    desc: '在这个武道为尊的世界，少年凭借坚韧意志一步步登上巅峰。打斗分镜行云流水，看得人热血沸腾。',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100/70 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-layout-grid-line"></i>
            推荐
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">精选推荐</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            编辑团队为你精心挑选的本周必读漫画，每一部都不容错过
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, i) => (
            <div
              key={i}
              className={`bg-background-100 rounded-xl overflow-hidden transition-all hover:bg-background-200/70 cursor-pointer ${
                i === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
              }`}
            >
              <div className="relative overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full object-cover"
                  style={{ aspectRatio: i === 0 ? '3/2' : '3/2' }}
                  onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
                />
                <span className="absolute top-3 left-3 bg-accent-500 text-background-50 text-xs font-medium px-2.5 py-1 rounded-full">
                  {card.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2">{card.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}